import { pluginKey } from './plugin-key';
export var cardAction = function cardAction(tr, action) {
  return tr.setMeta(pluginKey, action);
};
export var resolveCard = function resolveCard(url) {
  return function (tr) {
    return cardAction(tr, {
      type: 'RESOLVE',
      url: url
    });
  };
};
export var queueCards = function queueCards(requests) {
  return function (tr) {
    return cardAction(tr, {
      type: 'QUEUE',
      requests: requests
    });
  };
};
export var registerCard = function registerCard(info) {
  return function (tr) {
    return cardAction(tr, {
      type: 'REGISTER',
      info: info
    });
  };
};
export var removeCard = function removeCard(info) {
  return function (tr) {
    return cardAction(tr, {
      type: 'REMOVE_CARD',
      info: info
    });
  };
};
export var registerRemoveOverlay = function registerRemoveOverlay(callback, info) {
  return function (tr) {
    return cardAction(tr, {
      type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
      callback: callback,
      info: info
    });
  };
};
export var registerSmartCardEvents = function registerSmartCardEvents(smartLinkEvents) {
  return function (tr) {
    return cardAction(tr, {
      type: 'REGISTER_EVENTS',
      smartLinkEvents: smartLinkEvents
    });
  };
};
export var setProvider = function setProvider(cardProvider) {
  return function (tr) {
    return cardAction(tr, {
      type: 'SET_PROVIDER',
      provider: cardProvider
    });
  };
};
export var setDatasourceTableRef = function setDatasourceTableRef(datasourceTableRef) {
  return function (tr) {
    return cardAction(tr, {
      type: 'SET_DATASOURCE_TABLE_REF',
      datasourceTableRef: datasourceTableRef
    });
  };
};
export var setCardLayout = function setCardLayout(layout) {
  return function (tr) {
    return cardAction(tr, {
      type: 'SET_CARD_LAYOUT',
      layout: layout
    });
  };
};
export var setCardLayoutAndDatasourceTableRef = function setCardLayoutAndDatasourceTableRef(_ref) {
  var layout = _ref.layout,
    datasourceTableRef = _ref.datasourceTableRef;
  return function (tr) {
    return cardAction(tr, {
      type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
      layout: layout,
      datasourceTableRef: datasourceTableRef
    });
  };
};
export var showLinkToolbar = function showLinkToolbar(tr) {
  return cardAction(tr, {
    type: 'SHOW_LINK_TOOLBAR'
  });
};
export var hideLinkToolbar = function hideLinkToolbar(tr) {
  return cardAction(tr, {
    type: 'HIDE_LINK_TOOLBAR'
  });
};
export var showDatasourceModal = function showDatasourceModal(modalType) {
  return function (tr) {
    return cardAction(tr, {
      type: 'SHOW_DATASOURCE_MODAL',
      modalType: modalType
    });
  };
};
export var hideDatasourceModal = function hideDatasourceModal(tr) {
  return cardAction(tr, {
    type: 'HIDE_DATASOURCE_MODAL'
  });
};
export var clearOverlayCandidate = function clearOverlayCandidate(tr) {
  return cardAction(tr, {
    type: 'CLEAR_OVERLAY_CANDIDATE'
  });
};
export var setDatasourceStash = function setDatasourceStash(tr, datasourceStash) {
  return cardAction(tr, {
    type: 'SET_DATASOURCE_STASH',
    datasourceStash: datasourceStash
  });
};
export var removeDatasourceStash = function removeDatasourceStash(tr, url) {
  return cardAction(tr, {
    type: 'REMOVE_DATASOURCE_STASH',
    url: url
  });
};